// @flow

import { fromJS } from 'immutable';
import { loadEstimate } from '../State/estimate';

export type RecalculateEstimateItemParams = {
  estimateGroupIndex: number,
  estimateItemIndex: number
}

export default (params: RecalculateEstimateItemParams) => (dispatch: Function, getState: Function) => {

  let estimate = fromJS(getState().screens.EstimateView.estimate);

  let { quantity, rate, type } = estimate.getIn(['estimate_groups', params.estimateGroupIndex, 'estimate_items', params.estimateItemIndex]).toJS();
  const discountPercentage = estimate.get('discount_percentage');

  let subtotal, discount, total;

  // If type is TO (Title Only) or null, zero out all calculations
  if (!type || type === 'TO') {
    subtotal = '0.00';
    discount = '0.00';
    total = '0.00';
  } else {
    quantity = Number.isNaN(Number(quantity)) ? 0 :  Number(quantity);
    rate = Number.isNaN(Number(rate)) ? 0 :  Number(rate);

    subtotal = quantity * rate;
    discount = (subtotal / 100) * Number(discountPercentage);
    total = subtotal - discount;

    subtotal = subtotal.toFixed(2);
    discount = discount.toFixed(2);
    total = total.toFixed(2);
  }

  estimate = estimate.setIn(['estimate_groups', params.estimateGroupIndex, 'estimate_items', params.estimateItemIndex, 'subtotal'], subtotal);
  estimate = estimate.setIn(['estimate_groups', params.estimateGroupIndex, 'estimate_items', params.estimateItemIndex, 'discount'], discount);
  estimate = estimate.setIn(['estimate_groups', params.estimateGroupIndex, 'estimate_items', params.estimateItemIndex, 'total'], total);

  estimate = estimate.toJS();

  dispatch(loadEstimate(estimate));

}
